export var ReportFilterOptions;
(function (ReportFilterOptions) {
    ReportFilterOptions[ReportFilterOptions["Fiscal"] = 1] = "Fiscal";
    ReportFilterOptions[ReportFilterOptions["Default"] = 2] = "Default";
    ReportFilterOptions[ReportFilterOptions["Custom"] = 3] = "Custom";
})(ReportFilterOptions || (ReportFilterOptions = {}));
export var CompositeKeyTrend;
(function (CompositeKeyTrend) {
    CompositeKeyTrend["IMPROVING"] = "Improving";
    CompositeKeyTrend["STABLE"] = "Stable";
    CompositeKeyTrend["WORSENING"] = "Worsening";
})(CompositeKeyTrend || (CompositeKeyTrend = {}));
export var CompositeKeyRating;
(function (CompositeKeyRating) {
    CompositeKeyRating["STRONG"] = "Strong";
    CompositeKeyRating["STABLE"] = "Stable";
    CompositeKeyRating["VULNERABLE"] = "Vulnerable";
})(CompositeKeyRating || (CompositeKeyRating = {}));
export var EventRowSeverity;
(function (EventRowSeverity) {
    EventRowSeverity["LOW"] = "LOW";
    EventRowSeverity["WARNING"] = "WARNING";
    EventRowSeverity["CRITICAL"] = "CRITICAL";
    EventRowSeverity["A"] = "A";
    EventRowSeverity["B"] = "B";
    EventRowSeverity["C"] = "C";
    EventRowSeverity["D"] = "D";
    EventRowSeverity["DEFAULT"] = "DEFAULT";
})(EventRowSeverity || (EventRowSeverity = {}));
